/**
 * @param {object} data
 * @return {{ise_page: number}}
 */
export const search = (data) => ({
  ise_page: parseInt(data.ise_page, 10),
  resultat_recherche_moteur_interne: data.isResultFound,
});
